import { DoArraysOverlap } from "../../../../../shared/scripts/array-functions";
import { GetDateFromString } from "../../../../../shared/scripts/date-functions";
import { PadNumber } from "../../../../../shared/scripts/number-functions";
import { FormatStringColumnByLength } from "../../../../../shared/scripts/table-functions";
import { SiteActivationLookup } from "./site-activation.lookup";

export class SiteMilestone {

    SiteNumber: number;
    SiteName: string;
    OrderBy: number;
    DateCompletion: string;
    Comment: string;
    PrimeContractId: number;
    MilestoneId: number;
    //SiteIdStr: string;
    InPlay: number;
    //IsVanguardSite: number;

    PrimeContract: string;
    Milestone: string;

    SiteNumberDisplay: string;
    SiteNameDisplay: string;
    CommentDisplay: string;
    CompletionDate: Date;
    InPlayDisplay: string;
    //VanguardSiteDisplay: string;

    AppendixA: number;
    AppendixB: number;

    IsRecoverCohort: number; //0: false, 1: true
    MilestoneSiteHash: string;

    initialize(): void {

        this.PrimeContract = SiteActivationLookup.GetPrimeContract(this.PrimeContractId);
        this.Milestone = SiteActivationLookup.GetMilestone(this.MilestoneId);

        this.SiteNumberDisplay = PadNumber(this.SiteNumber + "", 3);
        this.SiteNameDisplay = FormatStringColumnByLength(this.SiteName, 4);
        this.CommentDisplay = FormatStringColumnByLength(this?.Comment, 4);

        this.CompletionDate = GetDateFromString(this.DateCompletion, "slash-month-day-year");

        //console.log(this.DateCompletion);
        //console.log(this.CompletionDate);

        this.MilestoneSiteHash = this.PrimeContractId + "-" + this.SiteNumber;

        this.InPlayDisplay = (this.InPlay == 1) ? "Yes" : "No";

        //if (this.IsVanguardSite == 1) this.VanguardSiteDisplay = "Yes";
        //else if (this.IsVanguardSite == 2) this.VanguardSiteDisplay = "No";
        //else this.VanguardSiteDisplay = "Not Applicable";

        //delete this.PrimeContractId;
        //delete this.MilestoneId;
        //delete this.IsVanguardSite;

        //console.log(this);
    }

    matchesFilter(primeContract: any, siteName: any, milestone: any, completedSinceDate: any, siteInPlay: any): boolean {

        //console.log(primeContract, contractType, statusGroup, changedSinceDate, addedSinceDate);
        //console.log(changedSinceDate, addedSinceDate);

        if (primeContract != undefined && !DoArraysOverlap(primeContract, this.PrimeContract)) { return false; }
        if (siteName != undefined && !DoArraysOverlap(siteName, this.SiteName)) { return false; }
        if (milestone != undefined && !DoArraysOverlap(milestone, this.Milestone)) { return false; }
        if (siteInPlay != undefined && !DoArraysOverlap(siteInPlay, this.InPlayDisplay)) { return false; }
        //if (vanguardSite != undefined && vanguardSite.indexOf(this.VanguardSiteDisplay) === -1) { return false; }
        if (completedSinceDate != undefined && completedSinceDate != null) {
            if (this.CompletionDate == undefined) { return false; }
            else if (this.CompletionDate < completedSinceDate) return false;
        }

        return true;
    }

    //getTrimmedMilestone(): TrimmedMilestone {
    //    return new TrimmedMilestone(this.Milestone, this.DateCompletion);
    //}

    getHash(): string {
        return this.SiteNumber + "-" + this.Milestone;
    }
}

export class MilestonesBySite {
    SiteNumber: number;
    //SiteIdStr: string;
    SiteName: string;
    PrimeContractId: number;
    PrimeContract: string;

    SiteNumberDisplay: string;
    SiteNameDisplay: string;
    InPlayDisplay: string;
    VanguardSiteDisplay: string

    MilestoneCompletionDates: string[]; //index is MilestoneId

    RandomizedCount: number;
    PI: string;
    AppendixA: number;
    AppendixB: number;

    constructor(primeContractId: number, siteNumber: number, siteNumberDisplay: string, siteName: string, PI: string, primeContract: string, inPlay: string, vanguardSite: any, AppendixA: number, AppendixB: number, randomized: number = -1) {

        this.PrimeContractId = primeContractId;
        this.SiteNumber = siteNumber;
        this.SiteNumberDisplay = siteNumberDisplay;
        //this.SiteIdStr = siteIdStr;
        this.SiteName = siteName;
        this.PI = PI;
        this.SiteNameDisplay = FormatStringColumnByLength(this.SiteName, 4);
        this.PrimeContract = primeContract;
        this.InPlayDisplay = inPlay;
        this.VanguardSiteDisplay = vanguardSite;
        this.MilestoneCompletionDates = [];
        this.RandomizedCount = randomized;
        this.AppendixA = AppendixA;
        this.AppendixB = AppendixB;
    }

    matchesFilter(primeContract: any, siteInPlay: any, vanguardSite: any): boolean {

        if (primeContract != undefined && !DoArraysOverlap(primeContract, this.PrimeContract)) { return false; }
        if (siteInPlay != undefined && !DoArraysOverlap(siteInPlay, this.InPlayDisplay)) { return false; }
        if (vanguardSite != undefined && !DoArraysOverlap(vanguardSite, this.VanguardSiteDisplay)) { return false; }

        return true;
    }
}

export class SiteMetricSummary {
    StudyId: number;
    MetricId: number;
    CompletedId: number;
    OrderBy: number;
    NumberOfSites: number;
    Mean: string;
    Min: string;
    Q1: string;
    Median: string;
    Q3: string;
    Max: string;
    InPlayId: number;

    MeanValue: number;
    MinValue: number;
    Q1Value: number;
    MedianValue: number;
    Q3Value: number;
    MaxValue: number;
    AppendixA: number;
    AppendixB: number;

    initialize() {
        this.MeanValue = Number.parseFloat(this.Mean) || 0;
        this.MinValue = Number.parseFloat(this.Min) || 0;
        this.Q1Value = Number.parseFloat(this.Q1) || 0;
        this.MedianValue = Number.parseFloat(this.Median) || 0;
        this.Q3Value = Number.parseFloat(this.Q3) || 0;
        this.MaxValue = Number.parseFloat(this.Max) || 0;
    }
}

export class SiteMetricDetail {
    StudyId: number;
    MetricId: number;
    CompletedId: number;
    SiteId: number;
    Dropped: number;
    Days: string;
    FirstMilestone: string;
    SecondMilestone: string;

    SiteName: string;

    DaysValue: number;
    SiteIdDisplay: string;

    AppendixA: number;
    AppendixB: number;

    initialize() {
        this.DaysValue = Number.parseInt(this.Days) || 0;
        this.SiteIdDisplay = String(this.SiteId).padStart(3, '0');
    }
}

export class SiteMetricBenchmark {
    Id: number;
    StudyId: number;
    MetricId: number;
    YellowDays: number;
    RedDays: number;

    initialize() {}
}